import { COMMON_STRING } from '@/constants/dictionary';
import { ApplicationInformation } from '@/service/types';

export const getAppVersionValue = (
  applicationInformation?: ApplicationInformation | null,
) => {
  if (
    !applicationInformation ||
    (!applicationInformation.scoringAppType &&
      !applicationInformation.scoringAppVersion)
  ) {
    return COMMON_STRING.NOT_AVAILABLE;
  }

  return `${applicationInformation.scoringAppType ?? ''} ${
    applicationInformation.scoringAppVersion ?? ''
  }`.trim();
};
